module.exports = __webpack_public_path__ + "static/media/line_widget.af93e4e1.jpg";